import { render } from "./LoadingInsideAContainer.vue?vue&type=template&id=06be5218&ts=true"
import script from "./LoadingInsideAContainer.vue?vue&type=script&lang=ts"
export * from "./LoadingInsideAContainer.vue?vue&type=script&lang=ts"

import "./LoadingInsideAContainer.vue?vue&type=style&index=0&id=06be5218&lang=css"

import exportComponent from "C:\\NEW DTC 2021\\ecpv\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__